module.exports = __webpack_public_path__ + "static/MEO_Logo_Eng-d21f70bfe4cc0db88764c0906e88e27e.svg";